import React from 'react';
import { Toaster } from 'sonner';
import {
  Navigation,
  FloatingButtons,
  HeroSection,
  ProblemSection,
  SolutionSection,
  ImpactSection,
  ExperiencesSection,
  WaterScreenGallerySection,
  SpecialEffectsSection,
  SkyMeetsWaterSection,
  ProcessSection,
  ApplicationsSection,
  VisualizaCampanaSection,
  FAQSection,
  ContactSection,
  Footer
} from '../components';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#030810] text-white">
      <Toaster position="top-center" richColors />
      <Navigation />
      <FloatingButtons />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <ImpactSection />
        <ExperiencesSection />
        <WaterScreenGallerySection />
        <SpecialEffectsSection />
        <SkyMeetsWaterSection />
        <ProcessSection />
        <ApplicationsSection />
        <VisualizaCampanaSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
